module.exports = "/_next/static/images/bc33283b45b9f692d6db1d946401ea96-estadao.png";